import TOML from "@iarna/toml";

export const parseToml = (text, path = "TOML") => {
  try {
    return { value: TOML.parse(text), error: null };
  } catch (error) {
    return {
      value: null,
      error: `${path}: ${error instanceof Error ? error.message : String(error)}`,
    };
  }
};
